import { Button } from 'antd';
import TableFilterContext from 'components/Forms/DataGrid/TableFilterContextProvider/TableFilterContext';
import React, { useContext } from 'react';
import TrackedBolHandler from '../../TrackedBolHandler';
import download from 'downloadjs';
import NotificationUtility from 'Core/NotificationUtility';
interface Props {
}

const TrackedBolGenerateReportButton: React.FC<Props> = (props) => {
  let context = useContext(TableFilterContext);
  let handler: TrackedBolHandler = new TrackedBolHandler(props);
  const downloadReport = () => {
    handler.GenerateReport(context.data!).then(x => {
      download(x.data, x.fileName, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    }).catch(err => {
      NotificationUtility.error('Error Generating Report', err.message || err, 1000, true);
    });
  }
  return <>  <Button size="default" type="primary" icon="file-excel" onClick={downloadReport} >Generate Report</Button>
  </>;
}

export default TrackedBolGenerateReportButton;